import type { ApiPreferredListingType } from '#/api/types/ApiPreferredListingType';
import type { I18nFn } from '#/i18n/types/I18nFn';

export const PREFERRED_LISTING_TYPE_CHECKBOX_OPTIONS = (
  i18n: I18nFn,
): { name: ApiPreferredListingType; label: string }[] => [
  { name: 'JOB', label: i18n('Jobs') },
  { name: 'INTERNSHIP', label: i18n('Internships') },
  { name: 'VOLOP', label: i18n('Volunteer Opportunities') },
  { name: 'EVENT', label: i18n('Events') },
  { name: 'NOT_SURE', label: i18n("I'm not sure") },
  { name: 'NOT_HERE_TO_POST', label: i18n("I'm not here to post") },
];
